import { Show, SimpleShowLayout } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import InfoSection from "./InfoSection";
import DurationProgressSection from "./DurationProgressSection";
import PeriodsSection from "./PeriodsSection";
import AdditionalTrainingsSection from "./AdditionalTrainingsSection";
import FinalExamSection from "./FinalExamSection";

const ShowAdvancedSpecializationSpecialist = () => {
  return (
    <Show
      title="Детайли за специализант"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <InfoSection />
        <DurationProgressSection />
        <PeriodsSection />
        <AdditionalTrainingsSection />
        <FinalExamSection />
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowAdvancedSpecializationSpecialist;